import {withTranslation} from '@wix/yoshi-flow-editor'
import {getComponentConfig, isListLayout, isSingleEventWidget} from '../../selectors/settings'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {EmptyState as EmptyStatePresentation} from './empty-state'
import {EmptyStateStateProps} from './interfaces'

const mapRuntimeToProps = ({state}: AppProps): EmptyStateStateProps => {
  const componentConfig = getComponentConfig(state)

  return {
    singleEventWidget: isSingleEventWidget(componentConfig),
    listLayout: isListLayout(componentConfig),
  }
}

export default connect<{}, EmptyStateStateProps>(mapRuntimeToProps)(withTranslation()(EmptyStatePresentation))
